console.log('From grid_h_cards component!!!');